import React from "react";
import { BlockField } from "..";
export var BlockFragment = function (_a) {
    var children = _a.children, queryVariables = _a.queryVariables;
    return (React.createElement(React.Fragment, null, children.map(function (block) { return (React.createElement(BlockField, { key: block.id, block: block, queryVariables: queryVariables })); })));
};
